import axios from "@/lib/axios";
import { serializeSortQueryParam } from "@/lib/utils";
import { SpringPage, SpringPageableRequest } from "@/types/apis";
import { Regime } from "@/types/company";
import { QuestionnaireResultStatus } from "@/types/questionnaries";

export type QuestionnaireResultsReportRequestParams = SpringPageableRequest & {
  companyId: string;
  editionId?: string;
  years?: number[];
};

export type QuestionnaireResultsReportResponseContent = {
  applicationQuizId: string;
  edition: {
    id: string;
    name: string;
    year: number;
  };
  applicant: {
    id: string;
    applicationId: string;
    name: string;
    regime: Regime;
    sector: {
      id: string;
      name: string;
    };
    subsector: {
      id: string;
      name: string;
    };
  };
  result: {
    score: number;
    resultStatus: QuestionnaireResultStatus;
  };
};

export type QuestionnaireResultsReportResponse =
  SpringPage<QuestionnaireResultsReportResponseContent>;

export const getQuestionnaireResultsReport = (
  params: QuestionnaireResultsReportRequestParams,
) =>
  axios
    .get<QuestionnaireResultsReportResponse>(
      `/v1/companies/${params.companyId}/reports/questionnaires/results`,
      {
        params: {
          companyId: params.companyId,
          editionId: params.editionId,
          years: params.years,
          page: params.page,
          size: params.size,
          sort: serializeSortQueryParam(params.sort),
        },
      },
    )
    .then((r) => r.data);
